// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__UxWxB","stats_container":"styles_stats_container__gjbgQ","stat_container":"styles_stat_container__GgEg_","dot":"styles_dot__oM1nQ"};